import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeading from "@/components/PageHeading/PageHeading";
import { useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { COMMISSION_TAB_ITEMS, getCommissionNavLinks } from "./_utils";
import { useRequireCommissionPlatform } from "./useCommissionPlatformGate";

export default function CommissionTabLayout({ children }: { children?: React.ReactNode }) {
  useRequireCommissionPlatform();
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const currentPath = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

  return (
    <AppLayout interior navLinks={getCommissionNavLinks()}>
      <Breadcrumb title="Commission Platform" backLink={{ to: "/billing/finance" }} />
      <PageHeading title="Commission Platform" compact />
      <Tabs
        tabItems={COMMISSION_TAB_ITEMS.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to),
          active: currentPath === to
        }))}
      />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
